import React from "react";

import { useParams, Navigate } from "react-router-dom";

import { BackLink } from "ds/Button";
import Loading from "ds/PageLoading";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import getUrl from "Libs/getUrl";
import { singleIntegrationSelector } from "Reducers/integration";
import ActivitySection from "src/organization/common/containers/ActivitySection/ActivitySection";

import useLoadIntegrations from "../useLoadIntegrations";

import Details from "./components/Details/Details";
import { Section } from "./IntegrationDetailsPage.styles";

const Detail = () => {
  const integration = useSelectorWithUrlParams(singleIntegrationSelector);
  const loading = useLoadIntegrations();
  const { organizationId, projectId } = useParams<{
    organizationId: string;
    projectId: string;
  }>();

  const integrationsURL = getUrl({
    key: "organization.project.settings.integrations",
    props: {
      organizationId: organizationId ?? "",
      projectId: projectId ?? ""
    }
  });

  if (loading) {
    return <Loading iconOnly />;
  }

  if (!integration) {
    return <Navigate to={integrationsURL} replace />;
  }

  return (
    <Section>
      <BackLink to={integrationsURL} from="integrations" capitalized={false} />
      <Details integration={integration} />
      <ActivitySection context={`integration.${integration?.type}`} />
    </Section>
  );
};

export default Detail;
